import React from 'react'
import { useDropzone } from 'react-dropzone';
import { ErrorMessage } from '.';

function _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

const Dropzone = ({ onChange }: { onChange: (b64: string) => void }) => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const onDrop = React.useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader()

            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                const binaryStr = reader.result;
                onChange(`data:${file.type};base64, ${_arrayBufferToBase64(binaryStr)}`);
            }
            reader.readAsArrayBuffer(file);
        });
    }, []);

    const onDropAccepted = React.useCallback(() => {
        setErrorMessage(null);
    }, []);

    const onDropRejected = React.useCallback((errors) => {
        const msg = [];
        for (const error of errors) {
            for (const err of error.errors) {
                msg.push(err.message);
            }
        }
        setErrorMessage(msg.join(', '));
    }, []);

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({ accept: 'image/png,image/jpeg', onDrop, onDropAccepted, onDropRejected, maxFiles: 1, maxSize: 5 * 1024 * 1024 });

    const style = React.useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]) as any;


    return (
        <div {...getRootProps()}>
            <input {...getInputProps({ style })} />
            {!!errorMessage && <ErrorMessage message={errorMessage}></ErrorMessage>}
        </div>
    );
}

export default Dropzone;

